import {Customer, CustomerRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {TableCell, Typography} from "@mui/material";
import {SoftChip} from "../../../../components/kit";
import {useApiManager} from "../../../../components/utils/api";

export const CustomerListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<Customer> = {
        title: "Clientes",
        onClick: "/app/admin/billing/customer",
        headers: [
            {title: "Cliente", width: "30%"},
            {title: "Razón social", width: "40%"},
            {title: "Descuento", width: "30%"},
        ],
        decorator: (bean: Customer) => (
            <>
                <TableCell sx={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                    <Typography variant="body2" fontWeight={600} noWrap>{bean.shortName}</Typography>
                    <Typography variant="caption" color="text.secondary">{bean.id}</Typography>
                </TableCell>
                <TableCell sx={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: "text.secondary"}}>
                    {bean.name}
                </TableCell>
                <TableCell>
                    {bean.discount?.name ? <SoftChip label={bean.discount.name} tone="info"/> : ""}
                </TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(CustomerRestControllerApiFactory);
            return ctrl.pageCustomer(
                currentPage,
                size,
                undefined,
                term,
                showDismissed
            );
        },
    };

    return (
        <>
            <AppList config={listConfig} />
        </>
    );
};
